// extracted by mini-css-extract-plugin
export var countdownContainer = "Countdown-module--countdownContainer--0c64d";
export var countdownDays = "Countdown-module--countdownDays--adfc9";
export var countdownInfo = "Countdown-module--countdownInfo--17849";
export var countdownTimer = "Countdown-module--countdownTimer--8debf";
export var countdownTimerItem = "Countdown-module--countdownTimerItem--05f60";
export var countdownTimerItemWrapper = "Countdown-module--countdownTimerItemWrapper--da90d";
export var countdownWrapper = "Countdown-module--countdownWrapper--1f67d";